import { BannerType } from '@/constants'
import type { BannerList, Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { useEffect, useRef } from 'react'
import { HomeWhite } from './Icon/HomeWhite'
import PageBreadcrumb from './PageBreadcrumb'
import { BannerBlog } from './ProductListing/BannerBlog'

interface BreadcrumbType {
  breadcrumbs: Post[]
  homeText?: string
  title?: string
  activeId?: string
  banner: BannerList[]
  postDetail?: Post
}

const PostBreadcrumb = ({
  breadcrumbs,
  title = 'Tin tức',
  activeId,
  banner,
  postDetail,
}: BreadcrumbType) => {
  const menuScrollRef = useRef<HTMLUListElement>(null)

  useEffect(() => {
    const menuScroll = menuScrollRef.current
    if (!menuScroll) return

    let isDown = false
    let startX: number
    let scrollLeft: number

    const handleMouseDown = (e: MouseEvent) => {
      isDown = true
      menuScroll.classList.add('active')
      startX = e.pageX - menuScroll.offsetLeft
      scrollLeft = menuScroll.scrollLeft
    }

    const handleMouseLeave = () => {
      isDown = false
      menuScroll.classList.remove('active')
    }

    const handleMouseUp = () => {
      isDown = false
      menuScroll.classList.remove('active')
    }

    const handleMouseMove = (e: MouseEvent) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - menuScroll.offsetLeft
      const walk = (x - startX) * 2 // Adjust scroll speed
      menuScroll.scrollLeft = scrollLeft - walk
    }

    menuScroll.addEventListener('mousedown', handleMouseDown)
    menuScroll.addEventListener('mouseleave', handleMouseLeave)
    menuScroll.addEventListener('mouseup', handleMouseUp)
    menuScroll.addEventListener('mousemove', handleMouseMove)

    return () => {
      menuScroll.removeEventListener('mousedown', handleMouseDown)
      menuScroll.removeEventListener('mouseleave', handleMouseLeave)
      menuScroll.removeEventListener('mouseup', handleMouseUp)
      menuScroll.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])
  return (
    <div className='breadCrumb'>
      {breadcrumbs &&
      breadcrumbs.length > 0 &&
      !breadcrumbs.some((breadcrumb: Post) => breadcrumb?._id === activeId) ? (
        <>
          <div className='flex items-center gap-x-1'>
            <PageBreadcrumb
              homeText={'Trang chủ'}
              breadcrumbs={[
                {
                  label: 'Tin tức',
                  href: '/post/tin-tuc',
                },
              ]}
              linkType={'post'}
            />

            {breadcrumbs && postDetail?.catIds && breadcrumbs.length > 0 && (
              <div className='categories flex gap-x-1'>
                <ul className='flex gap-x-1'>
                  {postDetail.catIds.map((catId: string) => {
                    const category = breadcrumbs.find(cat => cat._id === catId)
                    return category ? (
                      <>
                        <p key={catId} className='text-primary'>
                          {'/ '}
                          {getTranslate(category.name)} {'/ '}
                        </p>
                        <p className='text-dark-400'>
                          {getTranslate(postDetail?.title)}
                        </p>
                      </>
                    ) : null
                  })}
                </ul>
              </div>
            )}
          </div>
        </>
      ) : (
        breadcrumbs?.map((breadcrumb: Post) =>
          breadcrumb?._id === activeId ? (
            <PageBreadcrumb
              key={breadcrumb._id}
              homeText={'Trang chủ'}
              breadcrumbs={[
                {
                  label: title,
                  href: '/post/' + getTranslate(breadcrumb?.slugs?.value) || '',
                },
              ]}
              linkType={'post'}
            />
          ) : null
        )
      )}

      <BannerBlog
        sliders={
          banner?.find(
            (e: BannerList) => e.type === BannerType.BLOG && e.status === 1
          )?.items || []
        }
      />

      <div className='flex h-12 items-center gap-x-5 rounded-sm bg-white'>
        <Link
          href='/post'
          className={`home block h-12 rounded-l-lg px-4 ${
            !activeId && !postDetail?.catIds
              ? 'bg-primary text-white'
              : 'text-dark-400'
          }`}
        >
          <HomeWhite className='mt-3' />
        </Link>
        <ul
          ref={menuScrollRef}
          className='no-scrollbar menuScroll flex !list-none items-center gap-x-5 overflow-x-auto text-base text-dark-400'
        >
          {breadcrumbs?.map((e, index) => {
            const isActiveCategory = postDetail?.catIds?.includes(e?._id)
            return (
              <li
                className={` ${
                  isActiveCategory
                    ? 'active-category bg-primary px-4 py-[10px] text-white'
                    : ''
                } ${
                  e?._id === activeId && !isActiveCategory
                    ? 'bg-primary px-4 py-[10px] text-white'
                    : ''
                }`}
                key={`breadcumb-${index}`}
              >
                <Link
                  href={'/post/' + getTranslate(e?.slugs?.value) || ''}
                  className={`block whitespace-nowrap py-1 text-base font-bold ${
                    isActiveCategory ? 'font-semibold text-white' : ''
                  }`}
                >
                  {getTranslate(e?.name)}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
export default PostBreadcrumb
